export const formatarNumero = (index: number, tamanho =3) =>
  String(index + 1).padStart(tamanho, "0");
